import React, { useCallback, useEffect, useMemo, useState } from "react";
import CenteredLoading from "../../../../components/CenteredLoading";
import HotspotComponent from "../../../../components/Hotspot";
import { fetchWalletHotspots } from "../../../../context/hotspots/HotspotsProvider";
import { useViewport } from "../../../../context/viewport";
import { breakpoints } from "../../../../utils/constants";
import { EtlHotspot } from "../../../../utils/types";

interface Props {
  walletAddress: string;
}

const WalletHotspotsSection: React.FC<Props> = ({ walletAddress }) => {
  const [fetchedHotspots, setFetchedHotspots] = useState<EtlHotspot[]>([]);
  const [isFetchingHotspots, setIsFetchingHotspots] = useState(true);
  const { width } = useViewport();
  const isMobile = useMemo(() => width < breakpoints.sm, [width]);

  const handleFetchWalletHotspots = useCallback(async () => {
    const fetchedHotspots = await fetchWalletHotspots(walletAddress);

    setFetchedHotspots(fetchedHotspots || []);

    setIsFetchingHotspots(false);
  }, [walletAddress]);

  useEffect(() => {
    handleFetchWalletHotspots();
  }, [handleFetchWalletHotspots]);

  return (
    <aside
      className="p-6 col-span-4 xl:col-span-3 flex flex-col"
      style={
        isMobile
          ? {}
          : {
              maxHeight: "calc(100vh - 200px)",
              minHeight: "480px"
            }
      }
    >
      {isFetchingHotspots ? (
        <CenteredLoading className="flex-1" />
      ) : (
        <>
          <h3 className="text-md sm:text-xl font-bold mb-2">
            Wallet with {fetchedHotspots.length} hotspots
          </h3>

          <div className="flex-1 divide-y divide-gray-200 dark:divide-gray-500 sm:overflow-y-auto">
            {fetchedHotspots.map((hotspot) => (
              <HotspotComponent
                key={hotspot.id}
                hotspot={hotspot}
                withoutAvatarInMobile
              />
            ))}
          </div>
        </>
      )}
    </aside>
  );
};

export default WalletHotspotsSection;
